import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import { createContext, ReactNode, useContext, useEffect, useRef, useState } from "react";
interface PageTransitionContextType {
  isTransitioning: boolean;
  routePath: string;
}
const PageTransitionContext = createContext<PageTransitionContextType | undefined>(undefined);
export const PageTransitionProvider = t0 => {
  const $ = _c(13);
  const {
    children
  } = t0;
  const router = useRouter();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const timeoutRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== router.events) {
    t1 = () => {
      const handleRouteChangeStart = () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        setIsTransitioning(true);
      };
      const handleRouteChangeComplete = () => {
        timeoutRef.current = setTimeout(() => {
          setIsTransitioning(false);
          timeoutRef.current = null;
        }, 10);
      };
      router.events.on("routeChangeStart", handleRouteChangeStart);
      router.events.on("routeChangeComplete", handleRouteChangeComplete);
      router.events.on("routeChangeError", handleRouteChangeComplete);
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        router.events.off("routeChangeStart", handleRouteChangeStart);
        router.events.off("routeChangeComplete", handleRouteChangeComplete);
        router.events.off("routeChangeError", handleRouteChangeComplete);
      };
    };
    t2 = [router.events];
    $[0] = router.events;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== isTransitioning || $[4] !== router.asPath) {
    t3 = {
      isTransitioning,
      routePath: router.asPath
    };
    $[3] = isTransitioning;
    $[4] = router.asPath;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = isTransitioning ? "page-transition-out" : "page-transition-in";
  let t5;
  if ($[6] !== children || $[7] !== router.asPath || $[8] !== t4) {
    t5 = <div key={router.asPath} className={t4}>{children}</div>;
    $[6] = children;
    $[7] = router.asPath;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <PageTransitionContext.Provider value={t3}>{t5}</PageTransitionContext.Provider>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export const usePageTransitionCntx = () => {
  const context = useContext(PageTransitionContext);
  if (context === undefined) {
    throw new Error("usePageTransitionCntx must be used within a PageTransitionProvider");
  }
  return context;
};